<ng-container>
  <div class="app-layout">
    <app-nav-bar>
      <main class="app-content">
        <app-contained-loader *ngIf="appContentLoader.loading$ | async"></app-contained-loader>
        <router-outlet></router-outlet>
      </main>
    </app-nav-bar>
  </div>
</ng-container>

<router-outlet name="modal"></router-outlet>
<router-outlet name="secondaryModal"></router-outlet>
<router-outlet name="tertiaryModal"></router-outlet>
<router-outlet name="message"></router-outlet>
<router-outlet name="selector"></router-outlet>
